import React from 'react';
import s from '../styles/Loader.module.css';

const Loader = () => {
  return (
    <div className={s.loader_container}>
  <div className={s.loadingio}><div className={s.ldio}>
<div></div><div></div>
</div></div></div>
  );
};

export default Loader;
